import { BusinessRole } from '../../../../types/api/user'

export const PRINT_PLAN_EDIT_ROLES = [
    BusinessRole.SuperAdmin,
    BusinessRole.PrintTaskManager,
]
